// extracted by mini-css-extract-plugin
export default {"errorCard":"ErrorCard_errorCard__htJP-","name":"ErrorCard_name__bYQub","message":"ErrorCard_message__pdPwu"};